var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivateGym(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5625 18.8125H14.5C14.1203 18.8125 13.8125 19.1203 13.8125 19.5V30.5C13.8125 30.8797 14.1203 31.1875 14.5 31.1875H16.5625C16.9422 31.1875 17.25 30.8797 17.25 30.5V19.5C17.25 19.1203 16.9422 18.8125 16.5625 18.8125Z",
    stroke: "#2A3842",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 18.8125H23.4375C23.0578 18.8125 22.75 19.1203 22.75 19.5V30.5C22.75 30.8797 23.0578 31.1875 23.4375 31.1875H25.5C25.8797 31.1875 26.1875 30.8797 26.1875 30.5V19.5C26.1875 19.1203 25.8797 18.8125 25.5 18.8125Z",
    stroke: "#2A3842",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1875 20.875H28.25C28.4323 20.875 28.6072 20.9474 28.7361 21.0764C28.8651 21.2053 28.9375 21.3802 28.9375 21.5625V28.4375C28.9375 28.6198 28.8651 28.7947 28.7361 28.9236C28.6072 29.0526 28.4323 29.125 28.25 29.125H26.1875",
    stroke: "#2A3842",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8125 29.125H11.75C11.5677 29.125 11.3928 29.0526 11.2639 28.9236C11.1349 28.7947 11.0625 28.6198 11.0625 28.4375V21.5625C11.0625 21.3802 11.1349 21.2053 11.2639 21.0764C11.3928 20.9474 11.5677 20.875 11.75 20.875H13.8125",
    stroke: "#2A3842",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 25H22.75",
    stroke: "#2A3842",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9375 25H30.3125",
    stroke: "#2A3842",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6875 25H11.0625",
    stroke: "#2A3842",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3047 12C21.2377 12 22.8047 10.433 22.8047 8.5C22.8047 6.567 21.2377 5 19.3047 5C17.3717 5 15.8047 6.567 15.8047 8.5C15.8047 10.433 17.3717 12 19.3047 12Z",
    stroke: "#2A3842",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.0625C14.5375 14.1313 15.3108 13.3579 16.2419 12.8202C17.1731 12.2826 18.2294 11.9995 19.3047 11.9995C20.3799 11.9995 21.4363 12.2826 22.3674 12.8202C23.2986 13.3579 24.0718 14.1313 24.6094 15.0625",
    stroke: "#2A3842",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateGym);
export default __webpack_public_path__ + "static/media/privateGym.fe6e7343a874b656aad4cdb176ac6544.svg";
export { ForwardRef as ReactComponent };